"use client";

import { buttonVariants } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import { GetLomdaV3ResponseType } from "../../hooks/useGetLomdaV3";
import { Label } from "@/components/ui/label";
import DeleteLomdaV3Button from "./deleteButton";
import DuplicateLomdaV3Button from "./duplicateButton";
import { useStorage } from "@/features/storage/useStorage";
import { t } from "@/lib/localization";

export default function LomdaV3SheetHeader({
    lomda,
}: {
    lomda: GetLomdaV3ResponseType["data"];
}) {
    const setOpen = useStorage((state) => state.setLomdaV3SheetOpen);

    return (
        <header className="bg-white px-8 flex flex-row h-16 w-full justify-between items-center border-b">
            <div className="truncate flex flex-col">
                <Label className="truncate text-base">
                    {lomda?.name
                        ? t("lomda-sheet.header.title", undefined, {
                              lomdaName: lomda.name,
                          })
                        : t(
                              "lomda-sheet.header.title.placeholder",
                              undefined,
                              undefined
                          )}
                </Label>

                {!!lomda?.folders?.length && (
                    <p
                        className="truncate text-xs text-muted-foreground"
                        title={lomda.folders?.map((f) => f.name).join(", ")}
                    >
                        {t("lomda-sheet.header.folders", undefined, {
                            folderNames:
                                lomda.folders?.map((f) => f.name).join(", ") ||
                                "",
                        })}
                    </p>
                )}
            </div>

            <div className="hidden md:flex flex-row gap-2">
                <a
                    onClick={() => {
                        setOpen(false);
                    }}
                    href={`/lomda-v3/${lomda.id}`}
                    className={buttonVariants({
                        variant: "secondary",
                        size: "sm",
                    })}
                >
                    <Pencil className="size-3.5 me-2" />
                    {t("lomda-sheet.header.edit-btn", undefined, undefined)}
                </a>
                <DuplicateLomdaV3Button lomda={lomda} />
                <DeleteLomdaV3Button lomda={lomda} />
            </div>
        </header>
    );
}
